module.exports = {
      id: "personas:three-usage",
      viewBox: "0 0 37 44",
      url: "/static/" + "sprites.9a613551d588b36f01fd88ce7dbef123.svg#personas:three-usage",
      toString: function () {
        return this.url;
      }
    }